/**
 *
 * v.1.0  10/11/21  Inicial
 **/

import React from 'react'
import PropTypes from 'prop-types';
import { Dialog, Button, Icon } from "@blueprintjs/core";



class AvisoModal extends React.Component {
    getIconProps(tipo) {
        switch (tipo) {
            case "info":
                return { icon: "info-sign", intent: "primary" };
            case "warning":
                return { icon: "warning-sign", intent: "warning" };
            case "error":
                return { icon: "error", intent: "danger" };
            case "success":
                return { icon: "tick-circle", intent: "success" };
            default:
                return { icon: "info-sign", intent: "none" };
        }
    }

    render() {
        const { isOpen, tipo, titulo, mensaje, onClose } = this.props;
        const { icon, intent } = this.getIconProps(tipo);

        return (
            <Dialog
                isOpen={isOpen}
                onClose={onClose}
                title={
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <Icon icon={icon} intent={intent} />
                        <span>{titulo}</span>
                    </div>
                }
            >
                <div className="bp3-dialog-body">{mensaje}</div>
                <div className="bp3-dialog-footer">
                    <div className="bp3-dialog-footer-actions">
                        <Button intent="primary" onClick={onClose}>
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Dialog>
        );
    }
}

AvisoModal.propTypes = {
    tipo: PropTypes.string.isRequired,
    titulo: PropTypes.string,
    mensaje: PropTypes.string,
}

export default AvisoModal